import { Article } from "../../models/shared/Article";

export const compareArticles = (a: Article, b: Article) => {
    const orderDiff = (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity);
    if (orderDiff && !Number.isNaN(orderDiff)) return orderDiff;
    return (a.name || '').localeCompare(b.name || '');
}

export const sortArticles = <T extends Article>(articles: T[]): T[] => {
    return [...articles].sort(compareArticles);
}
